import { memo } from 'react';
import styled from 'styled-components';
import { withRole } from '../Common/withRole';
import { Users } from 'lucide-react';

const StyledAddTeamMemberButton = styled.button`
  background-color: var(--primary-green);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  
  &:hover {
    background-color: var(--primary-green-dark);
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

// Create the base button component
const AddButtonContent = memo(({ onAdd }) => (
  <StyledAddTeamMemberButton onClick={onAdd}>
    <Users size={16} />
    Add Team Member
  </StyledAddTeamMemberButton>
));

// Create the role-wrapped component
const WithRoleAddButton = withRole(AddButtonContent, { 
  managerOnly: true
});

// Create the final component that passes all props
const AddTeamMemberButton = memo(({ onAdd, isAdding, isManager, isAuthenticated }) => {
  return (
    <WithRoleAddButton 
      isManager={isManager}
      isAuthenticated={isAuthenticated}
      onAdd={onAdd}
    />
  );
});

export default AddTeamMemberButton;